import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  disabled?: boolean;
  isPartnerDealer?: boolean;
}

interface CheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  isPartnerDealer?: boolean;
}

interface LabelProps {
  disabled?: boolean;
  isPartnerDealer?: boolean;
  isFlex?: boolean;
}

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  &:hover {
    [role='checkbox'] {
      border-color: ${({ disabled }) => (disabled ? '' : COLORS.black)};
    }
  }

  ${({ disabled }: StyleProps) =>
    disabled &&
    css`
      cursor: not-allowed;
    `};
`;

export const Checkbox = styled.div<CheckboxProps>`
  width: 20px;
  height: 20px;
  border: ${({ checked, disabled, isPartnerDealer }) => {
    if (checked && disabled && isPartnerDealer) {
      return 'none';
    }
    if (checked) {
      return `1px solid ${COLORS.black}`; // checked
    }
    if (disabled) {
      return `1px solid ${COLORS.grey30}`; // disabled
    }
    return `1px solid ${COLORS.grey60}`; // default
  }};

  margin: 0 ${SIZING.unit(1.5)} 0 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: ${({ checked, disabled, isPartnerDealer }) =>
    checked && disabled && isPartnerDealer ? COLORS.grey15 : 'transparent'};
  &:hover {
    border-color: ${({ checked, disabled }) => (checked || disabled ? '' : COLORS.black)};
  }
  &:focus {
    outline: ${SIZING.unit(0.5)} auto Highlight;
    outline: ${SIZING.unit(0.5)} auto -webkit-focus-ring-color;
    ${({ disabled }) =>
      disabled &&
      css`
        outline: none;
      `};
  }
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : '')};
`;

export const Label = styled.label<LabelProps>`
  display: ${({ isFlex }) => (isFlex ? 'flex' : 'inline')};
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  /* color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.grey80)}; */
  color: ${({ disabled, isPartnerDealer }) => {
    if (disabled && isPartnerDealer) return COLORS.grey80;

    if (disabled) return COLORS.grey30;
    return COLORS.grey80;
  }};
  letter-spacing: 0.003px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const Hint = styled.div`
  color: ${COLORS.grey60};
  display: inline;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Count = styled.div`
  color: ${COLORS.grey60};
`;
